import { CheckoutStepType } from '../models'
import { CheckoutConfig } from './mb-checkout-config'
import { MbCheckoutTypes } from '../../models'

export const mbCheckoutConfig: CheckoutConfig = {
  checkout: {
    steps: [
      {
        id: 'quoteInfo',
        name: 'quoteInfo',
        routeName: 'checkoutQuoteInfo',
        type: [CheckoutStepType.QUOTE_INFO],
        isProgressBarStep: false,
        step: 3,
        checkoutTypes: [
          MbCheckoutTypes.CHECKOUT_TYPE_A,
          MbCheckoutTypes.CHECKOUT_TYPE_B,
          MbCheckoutTypes.CHECKOUT_TYPE_C
        ]
      },
      {
        id: 'contactDetails',
        name: 'checkoutProgressBar.contactDetails',
        routeName: 'checkoutContactDetails',
        type: [CheckoutStepType.CONTACT_DETAILS],
        isProgressBarStep: true,
        step: 4,
        checkoutTypes: [
          MbCheckoutTypes.CHECKOUT_TYPE_A,
          MbCheckoutTypes.CHECKOUT_TYPE_B,
          MbCheckoutTypes.CHECKOUT_TYPE_C,
          MbCheckoutTypes.CHECKOUT_TYPE_D,
          MbCheckoutTypes.CHECKOUT_TYPE_E
        ]
      },
      {
        id: 'shippingAddress',
        name: 'checkoutProgressBar.shippingAddress',
        routeName: 'checkoutShippingAddress',
        type: [CheckoutStepType.SHIPPING_ADDRESS],
        isProgressBarStep: true,
        step: 5,
        checkoutTypes: [
          MbCheckoutTypes.CHECKOUT_TYPE_A,
          MbCheckoutTypes.CHECKOUT_TYPE_B,
          MbCheckoutTypes.CHECKOUT_TYPE_C,
          MbCheckoutTypes.CHECKOUT_TYPE_D,
          MbCheckoutTypes.CHECKOUT_TYPE_E
        ]
      },
      {
        id: 'billingInformation',
        name: 'checkoutProgressBar.billingInformation',
        routeName: 'checkoutBillingInfo',
        type: [CheckoutStepType.BILLING_INFO],
        isProgressBarStep: true,
        step: 6,
        checkoutTypes: [
          MbCheckoutTypes.CHECKOUT_TYPE_A,
          MbCheckoutTypes.CHECKOUT_TYPE_B,
          MbCheckoutTypes.CHECKOUT_TYPE_C,
          MbCheckoutTypes.CHECKOUT_TYPE_D,
          MbCheckoutTypes.CHECKOUT_TYPE_E
        ]
      },
      {
        id: 'reviewOrder',
        name: 'checkoutProgressBar.review',
        routeName: 'checkoutReview',
        type: [CheckoutStepType.REVIEW],
        isProgressBarStep: true,
        step: 7,
        checkoutTypes: [
          MbCheckoutTypes.CHECKOUT_TYPE_A,
          MbCheckoutTypes.CHECKOUT_TYPE_B,
          MbCheckoutTypes.CHECKOUT_TYPE_C,
          MbCheckoutTypes.CHECKOUT_TYPE_D,
          MbCheckoutTypes.CHECKOUT_TYPE_E
        ]
      },
      {
        id: 'paymentProviderPage',
        name: 'paymentProviderPage',
        routeName: 'checkoutPaymentProviderPage',
        type: [CheckoutStepType.PAYMENT_PROVIDER_PAGE],
        isProgressBarStep: false,
        step: 8,
        checkoutTypes: [
          MbCheckoutTypes.CHECKOUT_TYPE_D,
          MbCheckoutTypes.CHECKOUT_TYPE_E
        ],
        allowGuard: false
      },
      {
        id: 'confirmation',
        name: 'confirmation',
        routeName: 'checkoutConfirmation',
        type: [CheckoutStepType.CONFIRMATION],
        isProgressBarStep: false,
        step: 9,
        checkoutTypes: [
          MbCheckoutTypes.CHECKOUT_TYPE_A,
          MbCheckoutTypes.CHECKOUT_TYPE_B,
          MbCheckoutTypes.CHECKOUT_TYPE_C,
          MbCheckoutTypes.CHECKOUT_TYPE_D,
          MbCheckoutTypes.CHECKOUT_TYPE_E
        ],
        allowGuard: true
      }
    ],
  },
}

